import type {AppLocale} from 'i18n/locales'
import bg from './faq-org.bg.json'
import de from './faq-org.de.json'
import en from './faq-org.en.json'
import sv from './faq-org.sv.json'
import tr from './faq-org.tr.json'
import type {OrgFaqKey} from './orgFaqKeys'

type Entry = {q: string; a: string}

const packs: Record<AppLocale, Record<string, Entry>> = {
  bg: bg as Record<string, Entry>,
  en: en as Record<string, Entry>,
  tr: tr as Record<string, Entry>,
  de: de as Record<string, Entry>,
  sv: sv as Record<string, Entry>,
}

export function getOrgFaqEntry(locale: AppLocale, key: OrgFaqKey): Entry {
  const pack = packs[locale] || packs.en
  return pack[key] || (packs.bg as Record<string, Entry>)[key]
}
